<template>
  <div>
    <v-row style="position: relative">
      <v-col cols="12" md="8" offset-md="4" class="portada"> </v-col>
      <v-row class="row-absolute">
        <v-col cols="12" sm="6" md="3" class="black py-12 col-black">
          <h1
            class="white--text text-uppercase ml-3 ml-md-6 mb-12"
            style="line-height: 1; font-size: 2.3rem"
          >
            Inscripciones <br />
            Abiertas
          </h1>
          <h5 class="white--text text-uppercase date-text">Nuevo inicio en:</h5>
          <div class="d-flex date-div">
            <div
              class="d-flex justify-center align-center flex-column mx-2"
              style="width: 100%"
            >
              <h3>{{ days }}</h3>
              <p><small> DIAS</small></p>
            </div>
            <div
              class="d-flex justify-center align-center flex-column mx-2"
              style="width: 100%"
            >
              <h3>{{ hours }}</h3>
              <p><small> HORAS</small></p>
            </div>
            <div
              class="d-flex justify-center align-center flex-column mx-2"
              style="width: 100%"
            >
              <h3>{{ minutes }}</h3>
              <p><small> MINUTOS</small></p>
            </div>
            <div
              class="d-flex justify-center align-center flex-column mx-2"
              style="width: 100%"
            >
              <h3>{{ seconds }}</h3>
              <p><small> SEGUNDOS</small></p>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
          class="blue d-flex justify-center align-start flex-column pl-6"
        >
          <h2 class="white--text text-uppercase">{{ date_init }}</h2>
          <p class="overline white--text">Inicio de diplomados</p>
        </v-col>
      </v-row>
    </v-row>
    <v-row
      class="d-flex justify-center align-center py-12"
      style="background-color: #111f3c !important"
    >
      <h3 v-if="$vuetify.breakpoint.mdAndUp" class="white--text text-center">
        <span class="text--ligth">Con</span> Universidad Vizcaya,
        <span class="text--ligth"
          >puedes titularte realizando uno de nuestros</span
        >
        cinco diplomados
        <span class="text--ligth"
          >que mejor se adapte a tus inspiraciones <br />
          profesionales. En tan solo 4 meses, y en una modalidad 100% en línea,
          lograrás el cambio profesional que estas buscando.</span
        >
      </h3>
      <h5 v-else class="white--text text-center px-5">
        <span class="text--ligth">Con</span> Universidad Vizcaya,
        <span class="text--ligth"
          >puedes titularte realizando uno de nuestros</span
        >
        tres diplomados
        <span class="text--ligth"
          >que mejor se adapte a tus inspiraciones <br />
          profesionales. En tan solo 4 meses, y en una modalidad 100% en línea,
          lograrás el cambio profesional que estas buscando.</span
        >
      </h5>
    </v-row>
    <v-row class="px-6" id="registrate-aqui">
      <v-col cols="12" md="4" class="d-flex justify-center align-center pt-6">
        <v-icon color="black" class="mx-2" style="font-size: 2rem"
          >mdi-calendar-month</v-icon
        ><span
          >Inicio <br />
          <h3>{{ date_init }}</h3></span
        >
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-center align-center pt-6">
        <v-icon color="black" class="mx-2" style="font-size: 2rem"
          >mdi-laptop</v-icon
        ><span
          >Duración <br />
          <h3>4 meses</h3></span
        >
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-center align-center pt-6">
        <v-icon color="black" class="mx-2" style="font-size: 2rem"
          >mdi-pencil</v-icon
        ><span
          >Inscripción <br />
          <h3>desde casa</h3></span
        >
      </v-col>
    </v-row>
    <!-- Aqui hay otro formulario -->
    <v-row class="px-6" id="registrate-aqui">
      <v-col cols="12" class="d-flex justify-center align-center pt-12">
        <v-card class="mb-12" style="background-color: #f7f7f7" width="100%">
          <v-layout
            :row="$vuetify.breakpoint.mdAndUp"
            class="mx-0"
            :column="$vuetify.breakpoint.smAndDown"
          >
            <v-flex
              xs12
              :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="NOMBRE (S)"
                      v-model="information.name_first"
                      placeholder="Juan"
                      type="text"
                      id="name_first"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="APELLIDOS"
                      v-model="information.last_name"
                      placeholder="López"
                      type="text"
                      id="last_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          label="FECHA DE NACIMIENTO"
                          v-model="computedDateFormatted"
                          placeholder="DD/MM/AAAA"
                          type="text"
                          id="birthday"
                          @click="datePicker = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="es"
                        v-model="information.birthday"
                        @input="menu1 = false"
                        ref="picker"
                        :max="new Date().toISOString().substr(0, 10)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="NÚMERO TELEFÓNICO"
                      v-model="information.phone"
                      placeholder="(123)-123-1212"
                      v-mask="'(###)-###-####'"
                      type="phone"
                      id="phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="CORREO ELECTRÓNICO"
                      v-model="information.email"
                      placeholder="correo@ejemplo.com"
                      type="email"
                      id="email"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-flex pb-0" cols="12" sm="12" md="6">
                    <v-select
                      :items="lic"
                      label="Diplomado de interés"
                      outlined
                      v-model="information.lic"
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex pb-0" cols="12" sm="12" md="6">
                    <v-select
                      :items="states"
                      label="Estado"
                      outlined
                      v-model="information.state"
                      item-value="key"
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" md="6">
                    <v-text-field
                      v-show="information.state == 'OTRO ESTADO'"
                      label="Otro estado"
                      v-model="information.other_state"
                      type="text"
                      id="other_state"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="6" sm="6" md="6">
                    <vue-recaptcha
                      @expired="successRecaptcha = false"
                      @verify="reCAPTCHAcallback()"
                      sitekey="6Lc8XKkbAAAAAEl5syMFnnddk1gllGQIxJ8RE4vx"
                      :loadRecaptchaScript="true"
                    ></vue-recaptcha>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pb-2">
                <v-layout
                  :row="$vuetify.breakpoint.mdAndUp"
                  :column="$vuetify.breakpoint.smAndDown"
                  :reverse="$vuetify.breakpoint.smAndDown"
                >
                  <div
                    class="flex-grow-1"
                    v-if="$vuetify.breakpoint.mdAndUp"
                  ></div>
                  <v-btn
                    rounded
                    :x-large="$vuetify.breakpoint.lgAndUp"
                    text
                    class="px-5"
                    @click="clearFields()"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    rounded
                    :x-large="$vuetify.breakpoint.lgAndUp"
                    color="primary"
                    class="px-5"
                    @click="submit()"
                    :disabled="isLoading || !successRecaptcha"
                    >Enviar formulario</v-btn
                  >
                </v-layout>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card>
      </v-col>
    </v-row>
    <!---->
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn color="white" dark text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>
<style scoped>
.animated {
  -webkit-animation: bounce 0.5s infinite alternate;
  animation: bounce 0.5s infinite alternate;
}

@-webkit-keyframes bounce {
  to {
    -webkit-transform: scale(1.1);
  }
}

@keyframes bounce {
  to {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
.text--ligth {
  font-weight: 300 !important;
}
.link-button-animated {
  width: 100%;
  display: flex;
  justify-content: center;
}
.cinto-color {
  padding-top: 6rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  background-image: url(/diplomados/barra.png);
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  height: auto;
  width: 100%;
}
.portada {
  background: rgb(17, 31, 60);
  padding-top: 6rem;
  padding-bottom: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url("/diplomados/portada_nueva.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
}
@media (max-width: 780px) {
  .portada {
    background-position: center;
    background-image: url("/diplomados/portada-web.jpg");
  }
  .cinto-color {
    background: transparent;
    padding-top: 6rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    background-image: url(/diplomados/barra.png);
    background-position: top center;
    background-size: contain;
    background-repeat: no-repeat;
    height: auto;
  }
}

@media (min-width: 1440px) {
  .cinto-color {
    padding-top: 8rem;
  }
}

@media (min-width: 2560px) {
  .cinto-color {
    padding-top: 18rem;
  }
}
/* 
New design
*/

.row-absolute {
  position: absolute;
  left: 2rem;
  bottom: 0;
  flex-direction: column;
  width: 80%;
}
.col-black {
  position: relative;
}
.date-div {
  position: absolute;
  bottom: 0;
  background: white;
  left: 0;
  right: 0;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

p {
  margin-bottom: 0px !important;
}

.date-text {
  position: absolute;
  bottom: 4.5rem;
  left: 40px;
}

.dip-img {
  height: 60px;
  margin-bottom: 4rem;
}

@media (min-width: 960px) and (max-width: 1264px) {
  .row-absolute {
    position: absolute;
    top: 35%;
    bottom: auto;
    left: 14%;
    flex-direction: row;
  }
  .date-div {
    position: absolute;
    bottom: -5rem;
    left: 0;
    right: 0;
    background: transparent;
  }
  .date-text {
    position: absolute;
    bottom: 1rem;
    left: 40px;
  }
  .dip-img {
    height: 60px;
  }
  .col-black {
    position: relative;
  }
}

@media (min-width: 1264px) and (max-width: 1904px) {
  .row-absolute {
    position: absolute;
    top: 35%;
    bottom: auto;
    left: 9%;
    flex-direction: row;
    width: 100%;
  }

  .date-div {
    position: absolute;
    bottom: -5rem;
    left: 0;
    right: 0;
    background: transparent;
  }
  .date-text {
    position: absolute;
    bottom: 1rem;
    left: 40px;
  }
  .dip-img {
    height: 60px;
  }
  .col-black {
    position: relative;
  }
}
@media (min-width: 1904px) {
  .row-absolute {
    position: absolute;
    top: 35%;
    bottom: auto;
    left: 16%;
    flex-direction: row;
    width: 70%;
  }

  .date-div {
    position: absolute;
    bottom: -5rem;
    left: 0;
    right: 0;
    background: transparent;
  }
  .date-text {
    position: absolute;
    bottom: 1rem;
    left: 40px;
  }
  .dip-img {
    height: 60px;
  }
  .col-black {
    position: relative;
  }
}
</style>
<script>
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import axios from "axios";
export default {
  directives: {
    mask,
  },
  mounted() {
    this.$store.dispatch("home/setModalImagen", false);
    let countDownDate = new Date("Jun 16, 2025 00:00:00").getTime();
    let self = this;
    // Update the count down every 1 second
    let x = setInterval(function () {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"
      self.days = days;
      self.hours = hours;
      self.minutes = minutes;
      self.seconds = seconds;

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);
  },
  data: () => ({
    successRecaptcha: false,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    nombre_completo: "",
    apellidos_completos: "",
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    sended: false,
    snackbar: false,
    snackbarColor: "info",
    snackbarText: "",
    fromlink: null,
    isLoading: false,
    publicPath: process.env.BASE_URL,
    campusSelected: "",
    menu2: false,
    menu1: false,
    offsetTop: 0,
    lic: [
      { key: "Gestion", text: "Gestión Estratégica personal" },
      { key: "Logistica", text: "Gestión Logística para el Comercio Exterior" },
      { key: "Estrategica", text: "Gestión Estratégica de Capital" },
      { key: "Aprendizaje", text: "Gestión de Evaluación del Aprendizaje" },
      { key: "Salud", text: "Salud pública" },
    ],
    states: [
      { key: "AGS", text: "AGUASCALIENTES" },
      { key: "BC", text: "BAJA CALIFORNIA" },
      { key: "BCS", text: "BAJA CALIFORNIA SUR" },
      { key: "CHI", text: "CHIHUAHUA" },
      { key: "CHS", text: "CHIAPAS" },
      { key: "CMP", text: "CAMPECHE" },
      { key: "CMX", text: "CIUDAD DE MEXICO" },
      { key: "COA", text: "COAHUILA" },
      { key: "COL", text: "COLIMA" },
      { key: "DGO", text: "DURANGO" },
      { key: "GRO", text: "GUERRERO" },
      { key: "GTO", text: "GUANAJUATO" },
      { key: "HGO", text: "HIDALGO" },
      { key: "JAL", text: "JALISCO" },
      { key: "MCH", text: "MICHOACAN" },
      { key: "MEX", text: "ESTADO DE MEXICO" },
      { key: "MOR", text: "MORELOS" },
      { key: "NAY", text: "NAYARIT" },
      { key: "NL", text: "NUEVO LEON" },
      { key: "OAX", text: "OAXACA" },
      { key: "PUE", text: "PUEBLA" },
      { key: "QR", text: "QUINTANA ROO" },
      { key: "QRO", text: "QUERETARO" },
      { key: "SIN", text: "SINALOA" },
      { key: "SLP", text: "SAN LUIS POTOSI" },
      { key: "SON", text: "SONORA" },
      { key: "TAB", text: "TABASCO" },
      { key: "TLX", text: "TLAXCALA" },
      { key: "TMS", text: "TAMAULIPAS" },
      { key: "VER", text: "VERACRUZ" },
      { key: "YUC", text: "YUCATAN" },
      { key: "ZAC", text: "ZACATECAS" },
      { key: "OTRO", text: "OTRO..." },
    ],
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      birthday: "",
      phone: "",
      grade: "",
      email: "",
      message: "Me interesa toda la información de los Diplomados en línea",
      lic: "",
      state: "",
      other_state: "",
      way: "",
      information: false,
    },
  }),
  computed: {
    ...mapState({
      date_init: (state) => state.home.date_init,
    }),
    computedDateFormatted() {
      return this.formatDate(this.information.birthday);
    },
  },
  watch: {
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    reCAPTCHAcallback() {
      this.successRecaptcha = true;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    validateEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone =
        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
    validateFields() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.lic != "" &&
        this.information.localidad != "" &&
        this.information.state != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar todos los campos";
        this.snackbar = true;
        this.snackbarColor = "dark";
      }
    },
    submit() {
      this.validateFields();
      if (this.valid) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      this.information.escolaridad = "Navidad Vizcaya";
      if (this.valid && this.emailValid && this.phoneValid) {
        this.sendInfoData();
      }
    },
    sendInfoData() {
      let self = this;
      self.isLoading = true;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("last_grade", "");
      formData.append("phone", this.information.phone);
      formData.append("message", this.information.message);
      formData.append("subject", "Diplomados en línea - Informes");
      formData.append("information_by_level", "Licenciatura");
      formData.append("carreer", this.information.lic);
      formData.append("municipality", this.information.state);
      formData.append("procedence", "Diplomados en línea");
      formData.append("comunication", "Diplomados en línea");
      formData.append("birthdate", "");
      formData.append("webpage", "Uva en línea");
      axios({
        method: "post",
        url: "https://www.informes-uva.tidingo.com/api/create-information",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        },
      })
        .then(function (response) {
          if (response.data.status == 200) {
            self.sended = true;
            self.snackbarText =
              "Información enviada, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.clearFields();
            self.$router.push("/gracias-informes");
          } else {
            self.snackbarText =
              "Ocurrio un error al enviar tu información, intentalo mas tarde";
            self.snackbarColor = "error";
            self.snackbar = true;
            self.clearFields();
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    clearFields() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        carrer: "",
        horarios: "",
        localidad: "",
        message: "Me interesa toda la información de los Diplomados en línea",
        licenciatura: false,
        posgrado: false,
        otros: false,
        escolaridad: "",
        school: "",
        way: "",
      };
    },
  },
};
</script>
